import { render, staticRenderFns } from "./SidePaneDrawer.vue?vue&type=template&id=1dd13373&scoped=true"
import script from "./SidePaneDrawer.vue?vue&type=script&lang=js"
export * from "./SidePaneDrawer.vue?vue&type=script&lang=js"
import style0 from "./SidePaneDrawer.vue?vue&type=style&index=0&id=1dd13373&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd13373",
  null
  
)

export default component.exports